"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemotionRiveCanvas = void 0;
var RemotionRiveCanvas_js_1 = require("./RemotionRiveCanvas.js");
Object.defineProperty(exports, "RemotionRiveCanvas", { enumerable: true, get: function () { return RemotionRiveCanvas_js_1.RemotionRiveCanvas; } });
